/* 대화방 지문의 표시용 줄 나누기 — 모델이 개행 없이 보낸 지문을 문장 끝에서 나눈다. 저장 글은 바꾸지 않는다.
   작가 · 모델이 직접 줄을 나눈 글과 상태창(```)은 그대로 둔다.
   따옴표 · 괄호 · 서식 기호 안이나 말줄임표(... …) · 숫자 목록(1.) · 약어(Mr.) 뒤에서는 나누지 않는다. */

const MIN_SPLIT_LENGTH = 40
/** 이보다 짧은 문장은 다음 문장과 한 줄에 둔다 — 짧은 문장마다 줄이 갈라지지 않게 */
const MIN_LINE_LENGTH = 20

const OPEN = '“‘「『《〈([{'
const CLOSE = '”’」』》〉)]}'

export function narrationLines(text: string): string[] {
  if (text.length < MIN_SPLIT_LENGTH || /\n|```/.test(text)) return [text]
  const lines: string[] = []
  let start = 0
  let depth = 0
  let quote = ''
  let marked = false
  for (let i = 0; i < text.length; i++) {
    const c = text[i]
    if (OPEN.includes(c)) depth++
    else if (CLOSE.includes(c)) depth = Math.max(0, depth - 1)
    else if (c === '"' || c === "'") quote = quote === c ? '' : quote || c
    else if (c === '*' || c === '`') {
      if (c === '*' && text[i + 1] === '*') i++
      marked = !marked
    } else if (
      '.!?'.includes(c) &&
      !depth &&
      !quote &&
      !marked &&
      /\s/.test(text[i + 1] ?? '') &&
      !/[.0-9A-Za-z]/.test(text[i - 1] ?? '') &&
      i + 1 - start >= MIN_LINE_LENGTH
    ) {
      lines.push(text.slice(start, i + 1))
      start = i + 1
    }
  }
  lines.push(text.slice(start))
  const trimmed = lines.map((line) => line.trim()).filter(Boolean)
  return trimmed.length > 1 ? trimmed : [text]
}
